import { render, staticRenderFns } from "./TransportFeeList.vue?vue&type=template&id=10bbbc4c&scoped=true&"
import script from "./TransportFeeList.vue?vue&type=script&lang=js&"
export * from "./TransportFeeList.vue?vue&type=script&lang=js&"
import style0 from "./TransportFeeList.vue?vue&type=style&index=0&id=10bbbc4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bbbc4c",
  null
  
)

component.options.__file = "TransportFeeList.vue"
export default component.exports